import React, {useContext} from 'react';
import {makeStyles} from "@material-ui/styles";
import Link from "next/link";
import {useTranslation} from 'tools/i18n';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import theme from "../theme";
import {Container} from "@material-ui/core";
import {TrackingContext} from "../providers/tracking";

const useStyles = makeStyles(theme => ({
	breadcrumbs__wrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%'
	},
	breadcrumbs__list: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		flexDirection: 'flex-start',
		width: '100%',
		padding: 0,
		margin: '8px 0',
		listStyle: 'none',
	},
	breadcrumbs__item: {
		'& a': {
			color: 'inherit',
			textDecoration: 'none'
		},
		'&.active': {
			'& a': {
				fontWeight: 500,
				textDecoration: 'none'
			},
			[theme.breakpoints.down('sm')]: {
				'& a': {
					fontWeight: 600
				}
			}
		},
		'&:not(:last-of-type):after': {
			content: '">"',
			margin: '0 6px'
		},
		'&:last-of-type a': {
			textDecoration: 'underline'
		},
		'&.product': {
			'& a, &:not(:last-of-type):after': {
				fontSize: 12,
				fontWeight: 300,
				color: '#000',
				[theme.breakpoints.up('md')]: {
					fontSize: '14px !important'
				}
			}
		}
	}
}));

export default function Breadcrumbs({breadcrumbs = {}, product = false, noGutters = false, className = ''}) {
	const classes = useStyles();
	const isFullwidth = useMediaQuery(theme.breakpoints.up('lg'));
	const {actions: trackingActions} = useContext(TrackingContext);
	const {t} = useTranslation('general');

	return (
		Object.keys(breadcrumbs).length > 1 ? <Container disableGutters={isFullwidth || noGutters} className={className}>
			<div className={classes.breadcrumbs__wrapper}>
				<ul className={classes.breadcrumbs__list}>
					<li className={[classes.breadcrumbs__item, product ? 'product' : ''].join(' ')} style={{display: 'none'}}>
						<Link href="/">
							{t('home')}
						</Link>
					</li>
					{breadcrumbs ? Object.keys(breadcrumbs).map((key, index) => (
						<li className={[classes.breadcrumbs__item, !product && index + 1 == Object.keys(breadcrumbs).length ? 'active' : '', product ? 'product' : ''].join(' ')} key={index}>
							<Link href={breadcrumbs[key].path}>
								<a onClick={() => trackingActions.click({type: product ? 'product_breadcrumbs_link' : 'category_breadcrumbs_link', text: breadcrumbs[key].name, identifier: breadcrumbs[key].path})}>
									{breadcrumbs[key].name}
								</a>
							</Link>
						</li>
					)) : ''}
				</ul>
			</div>
		</Container> : ''
	);
}
